<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    search
                    pagination="server">
                        <template #filters>
                            <payments-filter v-on:filter="filter"></payments-filter>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { PaymentApi } from '@/api/payment'
import PaymentsFilter from './components/PaymentsFilter.vue'
export default {
    components:{
        BCard,
        PaymentsFilter
    },
    data(){
        return {
            fields:[
                {name:'Netsis Dekont Kodu',key:'NetsisDocumentNo',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Banka Sip. No',key:'OrderId',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Cari Kodu',key:'CariCode',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Cari İsmi',key:'CariName',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'İşlem Başlama Tarihi',key:'CreateTime',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Ödeme İşlemi Tarihi',key:'PaymentTime',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Tutar (TL)',key:'Amount',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Taksit',key:'Installment',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Plasiyer',key:'PlasiyerFullName',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Banka',key:'Bank',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Tamamlandı',key:'IsCompleted',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Ödeme Başarılı',key:'IsPaymentSuccessfull',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Netsis Başarılı',key:'IsNetsisSuccessfull',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Netsis Özel Hesap Kapatma Başarılı',key:'IsNetsisOzelHesapKapatmaSuccessfull',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'Banka Hata - 1',key:'BankError',thClass:'w-25'},
                {name:'Banka Hata - 2',key:'BankError2',thClass:'w-5',tdClass:'text-nowrap'},
            ],
            filterData:{
                CreateTimeStart :null,
                CreateTimeEnd :null,
                IsCompleted :null,
                IsNetsisOzelHesapKapatmaSuccessfull :null,
                IsNetsisSuccessfull :null,
                IsPaymentSuccessfull :null,
                PlasiyerId :null,
            }
        }
    },
    methods:{
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        provider(data){
            return PaymentApi.List({
                Pagination:data,
                ...this.filterData
            })
        }
    }
}
</script>

<style>

</style>